import { useEffect, useMemo } from "react";
import { AttachmentCard } from "~/pages/manifold-nextgen/components/conversations/AttachmentCard";
import type { AttachmentItem } from "./useAttachmentTray";

// Composer-tray adapter: renders one pending attachment as an AttachmentCard.
// Images preview from a local object URL derived from the raw file, revoked when
// the chip unmounts. `uploading` shows a spinner while the send-time upload runs.
export const AttachmentChip = ({
  item,
  uploading,
  onRemove,
}: {
  item: AttachmentItem;
  uploading: boolean;
  onRemove: (key: string) => void;
}) => {
  const isImage = item.file.type.startsWith("image/");
  const imageUrl = useMemo(
    () => (isImage ? URL.createObjectURL(item.file) : undefined),
    [isImage, item.file]
  );
  useEffect(
    () => () => {
      if (imageUrl) URL.revokeObjectURL(imageUrl);
    },
    [imageUrl]
  );

  return (
    <AttachmentCard
      filename={item.filename}
      imageUrl={imageUrl}
      status={uploading ? "uploading" : "ready"}
      onRemove={() => onRemove(item.key)}
    />
  );
};
